import { render, staticRenderFns } from "./BdCategory.vue?vue&type=template&id=4c919234&scoped=true&"
import script from "./BdCategory.vue?vue&type=script&lang=js&"
export * from "./BdCategory.vue?vue&type=script&lang=js&"
import style0 from "./BdCategory.vue?vue&type=style&index=0&id=4c919234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c919234",
  null
  
)

export default component.exports